import Checkbox from '@allesauto/core/checkbox';
import ColorList from '@allesauto/core/colorList';
import { SchemaTypes } from '@allesauto/graphql';
import translate from '@allesauto/i18n';
import { getSlug } from '@allesauto/utils/funcs';
import clsx from 'clsx';
import React, { FC } from 'react';
import { useIntl } from 'react-intl';

export interface InteriorFilterValue {
  types: string[];
  colors: string[];
}

export interface InteriorFilterProps {
  types: SchemaTypes.InteriorType[];
  colors: SchemaTypes.InteriorColor[];
  selected: InteriorFilterValue;
  onChange: (filterOptions: InteriorFilterValue) => void;
}

const InteriorFilter: FC<React.PropsWithChildren<InteriorFilterProps>> = ({
  colors,
  types,
  onChange,
  selected,
}) => {
  const intl = useIntl();

  const trackingIdentifierInterior = 'aa-filter--interior';
  // TODO: Check if trackingIdentifierColor is needed
  // const trackingIdentifierInteriorColor = `${trackingIdentifierInterior}-color`;
  const trackingIdentifierInteriorType = `${trackingIdentifierInterior}-type`;

  const className = {
    container: 'grid grid-cols-1 h-full max-w-[500px]',
    infoTextType: 'leading-5 mb-30px text-p1 text-white',
    infoTextColors: 'leading-5 mb-20px mt-40px text-p1 text-white',
  };

  const { container, infoTextType, infoTextColors } = className;

  const onTypeClick = (type: string, checked: boolean) => {
    if (checked) {
      onChange({ ...selected, types: [...selected.types, type] });
    } else {
      onChange({
        ...selected,
        types: selected.types.filter((t) => t !== type),
      });
    }
  };

  const renderInteriorTypes = () =>
    types.map((it: SchemaTypes.InteriorType, i) => (
      <div className={clsx(i !== 0 && 'mt-20px')} key={i}>
        <Checkbox
          id={`${trackingIdentifierInteriorType}-${getSlug(it.name)}`}
          darkBg={true}
          label={it.displayName}
          onChange={(checked: boolean) => onTypeClick(it.name, checked)}
          checked={selected.types.indexOf(it.name) !== -1}
        />
      </div>
    ));

  return (
    <div className={container}>
      <div className={infoTextType}>
        {translate(intl, 'ui.INTERIOR_COLOR_LIST.interiorType')}
      </div>
      {renderInteriorTypes()}
      <div className={infoTextColors}>
        {translate(intl, 'ui.INTERIOR_COLOR_LIST.interiorColor')}
      </div>
      <ColorList
        hasShowMore={false}
        colors={colors.map((c) => ({
          ...c,
          isDefaultActive: selected.colors.includes(c.name),
        }))}
        onChange={(colors: string[]) =>
          onChange({
            ...selected,
            colors,
          })
        }
        selected={selected.colors}
      />
    </div>
  );
};

export default InteriorFilter;
